export default __webpack_public_path__ + "static/media/clock_white.799ff45d.svg";